import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CmsConfig,
  FeaturesConfigModule,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
} from '@spartacus/core';
import {
  defaultViewConfig,
  GlobalMessageComponentModule,
  IconModule,
  ItemCounterModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  PageComponentModule,
  SpinnerModule,
  StarRatingModule,
  ViewConfig,
} from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AddToEkCartModule } from '../../cart/shared/add-to-ekcart/add-to-ekcart.module';
import { AddEkWishListModule } from '../../wish-list/add-ek-wishlist/add-ek-wishlist.module';
import { ProductEkgridItemComponent } from '../product-ekgrid-item/product-ekgrid-item.component';
import { ProductEklistItemComponent } from '../product-eklist-item/product-eklist-item.component';
import { ProductEkscrollComponent } from '../product-ekscroll/product-ekscroll.component';
import { ProductEkviewComponent } from '../product-ekview/product-ekview.component';
import { ProductEkitemListComponent } from './product-ekitem-list.component';

@NgModule({
  imports: [
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    GlobalMessageComponentModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    AddEkWishListModule,
    AddToEkCartModule,
  ],
  providers: [
    provideDefaultConfig(<ViewConfig>defaultViewConfig),
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CMSProductListComponent: {
          component: ProductEkitemListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent'],
            },
          },
        },
        ProductGridComponent: {
          component: ProductEkitemListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent'],
            },
          },
        },
        SearchResultsListComponent: {
          component: ProductEkitemListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent'],
            },
          },
        },
      },
    }),
  ],
  exports: [
    ProductEkitemListComponent,
    ProductEkgridItemComponent,
    ProductEkviewComponent,
    ProductEkscrollComponent,
    ProductEklistItemComponent,
  ],
  declarations: [
    ProductEkitemListComponent,
    ProductEkgridItemComponent,
    ProductEkviewComponent,
    ProductEkscrollComponent,
    ProductEklistItemComponent,
  ],
})
export class ProductEkItemListModule {}
